import { ZoomStatus } from 'types';

interface ILessonWithMeta {
  zoomRecordingMeta?: { status: string } | null;
}

/**
 * Effective Zoom status of a lesson: the LessonRecording status when one
 * exists, otherwise the `NO_RECORDING` pseudo-status.
 */
export const lessonStatus = (lesson: ILessonWithMeta): ZoomStatus => {
  const meta = lesson.zoomRecordingMeta;
  if (!meta) {
    return ZoomStatus.NO_RECORDING;
  }
  return (meta.status as unknown) as ZoomStatus;
};
